import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import { Button as ReactButton } from '@mui/material';
import {
  ArrowBackIos,
  ControlPointDuplicate
} from '@mui/icons-material';
import { scrolledMoreThan } from '../../utils/window';
import { WithTracking } from "../WithTracking";
import { TrackingCtx  } from "../../tracking";
const Button = WithTracking(ReactButton);

const styles = theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  grow: {
    flexGrow: 1
  },
  flex: {
    flex: 1
  },
  bar: {
    minHeight: 50,
    background: theme.palette.common.white,
    borderBottom: '1px solid #c8c8c8'
  },
  buttons: {
    display: 'inline-block'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  extraMargin: {
    marginRight: 20
  }
});

class CopySettingsToolbar extends Component {

  state = {
    sticky: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.paint);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.paint);
  }

  paint = () => {
    const { sticky } = this.state;

    if (scrolledMoreThan(60) && !sticky) {
      this.setState({ sticky: true })
    }

    if (!scrolledMoreThan(60) && sticky) {
      this.setState({ sticky: false })
    }
  }

  render() {
    const {
      theme,
      onCopy,
      classes,
      canCopy,
      onBack
    } = this.props;

    const { sticky } = this.state;
    const background = sticky ? theme.palette.primary.light : theme.palette.common.white;

    return(
      <div className={classes.root}>
        <TrackingCtx.Consumer>
        {tracking => (
        <TrackingCtx.Provider value={{...tracking, action:"Copy Placement Settings"}}>        
        <Toolbar
          className={classes.bar}
          style={{background}}
        >
          <div className={classes.grow}>
            <div className={classes.buttons}>
              <Button color="primary" className={classes.extraMargin} onClick={onBack} tracking={{action: "Back to Placement"}}>
                <ArrowBackIos className={classes.leftIcon} />
                Back to Placement
              </Button>

              <Button color="primary" onClick={onCopy} disabled={!canCopy} tracking={{action: "Copy"}}>
                <ControlPointDuplicate className={classes.leftIcon} />
                Copy
              </Button>
            </div>
          </div>
        </Toolbar>
      </TrackingCtx.Provider>
      )}
      </TrackingCtx.Consumer>
      </div>
    )
  }
}

CopySettingsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  onCopy: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(CopySettingsToolbar);




